import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useItemGridStyles } from './styles';
import { Typography, ThemeProvider } from '@material-ui/core';
import classNames from 'classnames';
import { theme } from '../../../theme/theme';

export default function GroupedHeader(props) {
	const cx = classNames;
	const {
		columns,
		order,
		orderBy,
		onRequestSort,
		omniFilter,
		fontSize,
		paddingLeft,
		paddingRight,
		subHeaders,
		// dataLength,
		// numberOfRecords,
		// totalColumns,
		// isStore,
	} = props;
	const classes = useItemGridStyles({
		fontSize: fontSize,
		paddingLeft: paddingLeft,
		paddingRight: paddingRight,
	});
	const headerRef = useRef(null);
	const subHeaderRef = useRef(null);
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};
	const row1 = [];
	const row2 = [];

	columns?.map((header) => {
		if (header.children?.length === 0) {
			row1.push({
				id: header.id,
				label: header.label,
				align: header.align,
				rowSpan: 2,
				colSpan: 1,
				sortable: header.sortable,
			});
		} else {
			let noOfChildrenNotIncluded = 0;
			header.children?.map((item) => {
				if (item.visibleIn?.includes(omniFilter)) {
					row2.push({
						id: item.id,
						label: item.label,
						align: header.align,
						rowSpan: 1,
						colSpan: 1,
						sortable: item.sortable,
					});
				} else {
					noOfChildrenNotIncluded++;
				}
			});
			row1.push({
				id: header.id,
				label: header.label,
				align: header.align,
				rowSpan: 1,
				colSpan: header.children?.length - noOfChildrenNotIncluded,
				sortable: header.sortable,
			});
		}
	});

	function getSortDirection(orderById, currentId) {
		if (orderById === currentId) {
			return order;
		} else {
			return false;
		}
	}

	function getSpanHeaderClass(length) {
		if (length) {
			return classes.spanHeader;
		} else {
			return null;
		}
	}

	function getSortIconClass(orderById, currentId) {
		if (orderById === currentId) {
			return classes.sortIconActive;
		} else {
			return classes.sortIcon;
		}
	}

	const getSubTitle = (label) => {
		if (label === 'Net Sales') {
			return <div style={{ fontFamily: 'Bogle-Medium' }}>($)</div>;
		} else if (label === 'In-Stock' || label === 'WOW') {
			return (
				<div style={{ marginRight: '5px', fontFamily: 'Bogle-Medium' }}>
					(%)
				</div>
			);
		}
	};

	return (
		<ThemeProvider theme={theme}>
			<TableHead style={{ position: 'sticky', top: 0 }}>
				<TableRow
					ref={(el) => (headerRef.current = el)}
					sx={{ verticalAlign: 'baseline' }}>
					{row1?.map((row) => {
						let sortOrder = 'desc';
						if (orderBy === row.id) {
							sortOrder = order;
						}
						return (
							<TableCell
								key={row.id}
								role="columnheader"
								align={row.align}
								sortDirection={getSortDirection(orderBy, row.id)}
								style={{ borderBottom: 0 }}
								rowSpan={row.rowSpan}
								colSpan={row.colSpan}
								aria-rowspan={row.rowSpan}
								aria-colspan={row.colSpan}
								tabIndex={0}
								sx={{ padding: '0px' }}>
								<Typography
									className={cx(
										classes.tableCell,
										classes.tableHeader,
										`${getSpanHeaderClass(row.children?.length)}`
									)}>
									{`${row.label}`}
									{subHeaders && getSubTitle(row.label)}
									{row.sortable ? (
										<TableSortLabel
											direction={sortOrder}
											onClick={createSortHandler(row.id)}
											className={getSortIconClass(orderBy, row.id)}
										/>
									) : null}
								</Typography>
							</TableCell>
						);
					})}
				</TableRow>

				<TableRow ref={(el) => (subHeaderRef.current = el)}>
					{row2?.map((row) => (
						<TableCell
							key={row.id}
							align={row.align}
							tabIndex={0}
							sx={{
								borderBottom: 0,
								top: `${headerRef?.current?.clientHeight}px`,
								padding: '0px',
							}}>
							<Typography
								className={cx(classes.tableCell, classes.tableHeaderCellRow2)}>
								{row.label}
							</Typography>
						</TableCell>
					))}
				</TableRow>
				{/* {isStore && (
					<TableRow>
						<TableCell
							colSpan={totalColumns}
							sx={{
								backgroundColor: '#ECE9F3',
								color: '#3C228A',
								fontFamily: 'Bogle-Regular',
								fontSize: '12px',
								padding: '0px 16px',
								top: `${
									headerRef?.current?.clientHeight +
									subHeaderRef?.current?.clientHeight
								}px`,
							}}>
							{order === 'desc' ? 'Bottom' : 'Top'}{' '}
							{`${dataLength} of ${numberOfRecords.toLocaleString()} items`}
						</TableCell>
					</TableRow>
				)} */}
			</TableHead>
		</ThemeProvider>
	);
}

GroupedHeader.defaultProps = {
	fontSize: '16px',
	paddingLeft: '16px',
	paddingRight: '16px',
	subHeaders: false,
};

GroupedHeader.propTypes = {
	columns: PropTypes.arrayOf(PropTypes.shape({})),
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	omniFilter: PropTypes.string,
	paddingRight: PropTypes.string,
	paddingLeft: PropTypes.string,
	fontSize: PropTypes.string,
	subHeaders: PropTypes.bool,
	// dataLength: PropTypes.number,
	// numberOfRecords: PropTypes.number,
	// totalColumns: PropTypes.number,
	// isStore: PropTypes.bool,
};
